<div class="container">
  <header class="assistant-card" (click)="goToAiAssistant()">
    <div class="assistant-card__col1">
      <div class="assistant-card-mascot-ring" aria-hidden="true">
        <app-robocat-mascot-model class="assistant-card-mascot" />
      </div>
    </div>
    <div class="assistant-card__col2">
      <div class="title">{{ 'app.components.parentAiAssistant.title' | translate }}</div>
      <div class="subtitle">
        @if (selectedChild(); as child) {
          <span>{{ 'app.components.parentAiAssistant.subtitleHelpingWith' | translate:{ name: child.name } }}</span>
        } @else {
          <span>{{ 'app.components.parentAiAssistant.subtitleDefault' | translate }}</span>
        }
      </div>
    </div>
    <div class="assistant-card__col3 header-actions" (click)="$event.stopPropagation()">
      @if (!isNeutralChildScope()) {
        <button class="header-action-btn topics-btn" (click)="toggleTopicsPanel()" [class.active]="showTopicsPanel()">
          <span class="topics-icon">📋</span>
          @if (filteredTopics().length) {
            <span class="topics-count">{{ filteredTopics().length }}</span>
          }
        </button>
      }
    </div>
  </header>

  @if (!isNeutralChildScope()) {
  <div class="topics-panel" [class.open]="showTopicsPanel()" (click)="$event.stopPropagation()">
    <div class="topics-panel-header">
      <span class="panel-title">{{ 'app.components.parentAiAssistant.conversationTopics' | translate }}</span>
      <button type="button" class="close-panel-btn" (click)="toggleTopicsPanel()">✕</button>
    </div>
    @if (isLoadingTopics()) {
      <div class="topics-loading">{{ 'app.components.parentAiAssistant.loadingTopics' | translate }}</div>
    } @else {
      <div class="topics-filters">
        @for (item of topicCounts() | keyvalue; track item.key) {
          <span class="filter-tag">{{ getCategoryLabelKey(item.key) | translate }} <span class="tag-count">{{ item.value }}</span></span>
        }
      </div>
      <div class="topics-list">
        @for (topic of filteredTopics(); track topic.id) {
          <div
            class="topic-item"
            [class.active]="selectedTopic()?.id === topic.id"
            [class.resolved]="$any(topic).isResolved"
            (click)="selectTopic(topic)"
          >
            <div class="topic-severity" [style.background]="getSeverityColor(topic.severity)"></div>
            <div class="topic-content">
              <div class="topic-title">
                {{ topic.problemSummary }}
                @if ($any(topic).isResolved) {
                  <span class="resolved-check">✓</span>
                }
              </div>
              <div class="topic-info">
                <span>{{ getCategoryIcon(topic.primaryTopic) }} {{ getCategoryLabelKey(topic.primaryTopic) | translate }}</span>
                <span>{{ formatTimeAgo(topic.lastUpdatedDate) }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    }
    <button type="button" class="new-topic-btn" (click)="startNewConversation()">
      {{ 'app.components.parentAiAssistant.startNewConversation' | translate }}
    </button>
  </div>
  }
</div>
